/**
 * Environment Configuration Service
 * 
 * Detects the current environment based on the URL and returns
 * the appropriate adminApiUrl and apiKey for that environment.
 */

export interface EnvironmentConfig {
  adminApiUrl: string;
  apiKey: string;
}

export type Environment = 'dev' | 'test' | 'prod' | 'local';

/**
 * Detects the current environment based on window.location.href
 */
export function detectEnvironment(): Environment {
  const hostname = window.location.hostname;
  const href = window.location.href.toLowerCase();

  // Check for production (no dev/test in URL)
  if (href.includes('wb.isg-one.com') || hostname === 'wb.isg-one.com') {
    return 'prod';
  }

  // Check for test environment
  if (href.includes('wbtest.isg-one.com') || hostname === 'wbtest.isg-one.com') {
    return 'test';
  }

  // Check for dev environment
  if (href.includes('wbdev.isg-one.com') || hostname === 'wbdev.isg-one.com') {
    return 'dev';
  }

  // Default to local for localhost or other environments
  return 'local';
}

/**
 * Gets the environment-specific configuration
 */
export function getEnvironmentConfig(): EnvironmentConfig {
  const env = detectEnvironment();

  switch (env) {
    case 'dev':
      return {
        adminApiUrl: 'https://apigw.isg-one.com/wbngdev/',
        apiKey: '944c43171ae54b89aaf41dac59b9d06b'
      };

    case 'test':
      return {
        adminApiUrl: 'https://apigw.isg-one.com/wbngtest/',
        apiKey: 'd2d28aea774841008bb517905e262459'
      };

    case 'prod':
      return {
        adminApiUrl: 'https://api.isg-one.com/wbng/',
        apiKey: '66d5d8fc3ed44b79b9d4c794549d5ffc'
      };

    case 'local':
    default:
      return {
        adminApiUrl: 'https://localhost:7201/',
        apiKey: 'LOCAL_KEY_DO_NOT_NEED'
      };
  }
}

